import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosConfig from "axiosConfig";
import { ConfirmEmailType } from "types/AuthTypes";

const confirmEmail = async (credentials: ConfirmEmailType): Promise<any> => {
  const response = await axiosConfig.put(`/auth/activate`, credentials);
  return response.data;
};

export const useConfirmEmail = (
  options?: UseMutationOptions<any, Error, ConfirmEmailType>
) => {
  return useMutation({
    mutationKey: ["confirm-email"],
    mutationFn: async (credentials: ConfirmEmailType) => {
      return confirmEmail(credentials);
    },
    onError: (error, variables, context) => {
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
